export type SnFormUrlValidatorType = 'http' | 'rtmp' | 'rtsp' | 'dash' | 'hls' | 'ws';
